<div class="db-info-tooltip">
  <div class="db-info-tooltip__content-header">{{ 'tooltip_text_overview.score.widget.header' | dbText}}</div>
  <div class="db-info-tooltip__content-body">
    <div class="db-info-tooltip__score-section-scores-info">
      <div class="db-info-tooltip__score-section-scores-info-item" *ngFor="let score of scores">
        <div class="db-score-circle">
          <div class="db-score-number" [ngClass]="{'db-score-number-yellow': score.value >= 50 && score.value < 90,
              'db-score-number-red': score.value >= 0 &&  score.value < 50,
              'db-score-max': score.value === 100, 'db-score-single': score.value < 10}">{{score.value}}</div>
          <svg viewBox="0 0 120 120" *ngIf="score.value !== null">
            <circle class="db-bg-stroke" [ngClass]="{'db-stroke-yellow': score.value >= 50 && score.value < 90,
                'db-stroke-red': score.value >= 0 &&  score.value < 50}" r="56" cx="60" cy="60"></circle>
            <circle class="db-score-stroke" [ngClass]="{'db-score-stroke-yellow': score.value >= 50 && score.value < 90,
                'db-score-stroke-red': score.value >= 0 && score.value < 50 }"
                    transform="rotate(-90 60 60)" r="56" cx="60" cy="60"
                    attr.stroke-dasharray="{{radiusScore - (radiusScore * (1-((score.value) / 100)))}}, {{radiusScore}}"></circle>
          </svg>
        </div>
        <div class="db-score-desc">
          <div>
            <p class="db-google-score-site-url">{{`text_${score.name.toLocaleLowerCase()}` | dbText}}</p>
            <div *ngIf="score.loadTime">
              <b class="db-load-time">{{'text_moveTo10web.loadTime' | dbText}}: {{score.loadTime}}s</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-wrap" *ngIf="!demoUser">
      <button class="ds-btn-blue" *ngIf="showLearnMore" (click)="redirectToInner(websiteId)">
        <span>{{'text_googleSpinnerAdditionalMore' | dbText | lowerCaseSpecificWords}}</span>
      </button>
    </div>
  </div>
</div>
